/**
 * Coordonnées du support, les mêmes pour « Support & aide » et « Aide ».
 *
 * <p>Les deux pages portaient chacune les leurs, et elles ne disaient pas la
 * même chose. Aucun numéro de téléphone n'est affiché tant que le client n'a
 * pas fourni le vrai : une chaîne vide retire la ligne et le bouton.
 */
export const SUPPORT = Object.freeze({
  email: 'support@swisstech.tech',
  telephone: '',
  horaires: 'Lun–Ven, 8h–18h',
});

export const KB_SUPPORT = [
  [
    'Configurer ma société',
    "Réglages → Société : nom, adresse, IBAN, N° TVA, logo, langue. L'IBAN est nécessaire pour la QR-facture.",
    'démarrage réglages société iban logo',
  ],
  [
    'Changer de module / secteur',
    'Le module (Bâtiment, Magasin ou Mix) est fixé par ton abonnement : Plus → Abonnement → changer de module, réservé au patron. Tes données sont conservées. En Mix, ce sont deux sociétés séparées : le bouton en haut à droite passe de l’une à l’autre.',
    'module secteur bâtiment magasin mix changer',
  ],
  [
    'Ajouter un article',
    "Stock → « ＋ Nouvel article ». Remplis Nom, Catégorie (corps de métier), Unité, Prix d'achat, Prix de vente, Stock. Puis ✓ Ajouter.",
    'article stock ajouter produit magasin',
  ],
  [
    'Ajouter un corps de métier / rayon',
    "Deux façons : (1) sur l'écran Nouvel article, bouton vert « ＋ Nouveau corps de métier » ; (2) tape le nom dans le champ Catégorie. Il devient un bouton réutilisable.",
    'corps métier catégorie rayon ajouter créer',
  ],
  [
    'Ajouter un article dans un corps de métier précis',
    'Dans Stock, touche le corps de métier voulu en haut (ex. Carrelage) : le bouton devient « ＋ Ajouter dans Carrelage » et pré-remplit la catégorie.',
    'article corps métier catégorie ajouter dans',
  ],
  [
    'Conditionnements (palette, carton, rouleau)',
    'Formulaire article → Conditionnements : « Rouleau = 200 m », « Palette = 10 rouleaux », « Carton = 25 tubes ». Conversions automatiques (Palette = 2000 m).',
    'conditionnement palette carton rouleau conversion unité',
  ],
  [
    'Unités (pièce, m², ml, kg…)',
    'Le champ Unité est libre : pièce, m², ml, m³, rouleau, sac, tube, kg, litre… Ajoute tes unités dans Réglages → Préférences → Mon activité : elles sont enregistrées avec la société.',
    'unité pièce m2 ml kg litre mesure',
  ],
  [
    'Que veut dire « Stock » ?',
    "« Stock » = la quantité que tu as, DANS l'unité choisie. Unité ml → stock en mètres ; unité pièce → nombre de pièces.",
    'stock quantité unité pièce ml',
  ],
  [
    'Alerte de stock bas',
    "Chaque article a un seuil « Alerte mini ». Sous ce seuil, une alerte s'affiche (stock, accueil, et dans l'offre : « à recommander »).",
    'alerte stock bas minimum seuil recommander',
  ],
  [
    'Sortie de stock / réapprovisionner',
    'Sur chaque article : « Sortie » (retirer du stock) ou « Achat » (réapprovisionner). Le stock se met à jour.',
    'sortie achat réappro stock mouvement fournisseur',
  ],
  [
    'Vente au-delà du stock (garde-fou)',
    "À la caisse, si tu mets plus que le stock, une alerte rouge s'affiche et Encaisser est bloqué. Ajuste ou réapprovisionne.",
    'garde-fou stock insuffisant vente bloquer caisse',
  ],
  [
    "Import d'articles en lot",
    "Stock → « 📋 Ajout en lot » : une ligne par article (nom, quantité de départ, prix d'achat, prix de vente), la facture fournisseur jointe, puis « ✓ Tout ajouter au stock ».",
    'import lot masse articles liste',
  ],
  [
    "Photo et code-barres d'un article",
    'Formulaire article : « Ajouter une photo » et le champ Code-barres (EAN). « 📷 Scanner avec la caméra » lit le code quand le navigateur le permet (Chrome, Edge) ; sinon, tape-le ou utilise une douchette.',
    'photo code-barres ean article scan',
  ],
  [
    'Régler les remises par client',
    '% Remises → choisis le client → un % sur chaque article (ou remise générale). Enregistre.',
    'remise client pourcentage prix réduction',
  ],
  [
    'Envoyer un catalogue au client',
    '% Remises → « 📤 Envoyer le catalogue » (prix remisés) ou « 📄 Catalogue prix de base » (prospect).',
    'catalogue client prix envoyer prospect',
  ],
  [
    "Les remises dans l'offre",
    "En choisissant un client dans une offre, ses remises s'affichent et s'appliquent automatiquement (public barré → prix client) + le stock restant.",
    'remise offre client automatique prix',
  ],
  [
    'Faire une vente au comptoir',
    'Ventes → « Nouvelle vente » → panier → paiement → Encaisser. Le stock se met à jour, ticket généré.',
    'vente caisse comptoir encaisser ticket panier',
  ],
  [
    'Rapport Z (caisse)',
    'Ventes → Rapport Z : récapitulatif des ventes du jour (total, moyens de paiement).',
    'rapport z caisse journée ventes',
  ],
  [
    'Créer un devis / une offre',
    'Offres → « Nouvelle offre » → modèle → client → lignes → acompte → Générer. Le client peut signer.',
    'devis offre créer modèle client ligne',
  ],
  [
    'Faire signer un devis',
    "Le client signe à l'écran, au doigt, sur ton appareil. Par son lien, il consulte l'offre à distance, l'accepte en signant ou la refuse en donnant un motif : le statut et le motif reviennent sur la pièce, au bureau.",
    'signature devis signer client qr refuser refus motif lien',
  ],
  [
    'Nommer mes pièces « Offre » ou « Devis »',
    'Réglages → Documents → « Nom du document » : Offre, Devis ou Auto (Offre au magasin et en Suisse, Devis en France). Le mot choisi vaut partout : écran, PDF, e-mail, page du client, boutons et statuts.',
    'offre devis nom document mot réglages terminologie',
  ],
  [
    'Convertir un devis en facture',
    'Sur un devis accepté : « Convertir en facture » — lignes et client repris automatiquement.',
    'convertir devis facture transformer',
  ],
  [
    'Créer une facture',
    "Factures → Nouvelle (ou depuis un devis). QR-facture si l'IBAN est renseigné. Suis le paiement, envoie des rappels.",
    'facture créer qr paiement',
  ],
  [
    'QR-facture suisse',
    "Renseigne l'IBAN (Réglages → Société). Chaque facture génère un bulletin QR conforme suisse, scannable par les apps bancaires.",
    'qr facture suisse iban bulletin six',
  ],
  [
    'Marquer une facture payée / rappels',
    'Marque la facture payée (compte dans le CA). Les retards apparaissent dans « À traiter » avec un rappel.',
    'facture payée rappel relance retard encaisser',
  ],
  [
    'Avoir / facture rectifiée',
    'Crée un avoir (note de crédit) pour corriger/annuler une facture — montants négatifs corrects.',
    'avoir note crédit rectifiée annuler facture',
  ],
  [
    'Import bancaire (rapprochement)',
    'Factures → importe un relevé camt.054 : les paiements sont pointés automatiquement sur les factures (référence QR).',
    'banque camt rapprochement paiement import',
  ],
  [
    'Comptabilité (résultat, marge)',
    'Comptabilité : CA, marges, bénéfice, coûts. Agrège factures payées + dépenses. Export CSV fiduciaire.',
    'comptabilité résultat marge bénéfice ca',
  ],
  [
    'Décompte TVA',
    'Comptabilité → Décompte TVA : TVA collectée/due selon tes factures et ventes, déductible sur tes frais, chaque pièce au taux en vigueur à sa date.',
    'tva décompte taux déclaration',
  ],
  [
    'Changer le taux de TVA',
    "Réglages → Documents → « Taux de TVA » : les trois taux légaux (normal, réduit, hébergement) avec leur date d'entrée en vigueur. Quand la loi change, « Ajouter un changement de taux dès le … » : les documents déjà établis gardent leur taux, les nouveaux prennent celui en vigueur. La TVA par défaut des documents se choisit parmi ces taux (ou 0 % si non assujetti).",
    'tva taux changer loi 2024 hébergement réduit normal',
  ],
  [
    'Ajouter un employé',
    'Équipe & paie → Ajouter un employé. Fiche : identité, N° AVS (une seule fois), contrat, banque, permis, etc.',
    'employé ajouter équipe paie fiche',
  ],
  [
    'Fiche de salaire',
    'Équipe & paie → employé → Fiche de salaire. Brut, déductions (AVS/AC/LAA/LPP), impôt source, net calculés.',
    'salaire fiche paie brut net déduction avs',
  ],
  [
    'Taux des charges sociales',
    'Réglages → Charges sociales : les taux (AVS/AI/APG, AC, AANP/AAP, allocations familiales, frais d’administration, IJM) se règlent par année. Chaque janvier, vérifie les taux dans Réglages → Charges sociales et prépare la nouvelle année ; chaque fiche de paie applique ceux de son année.',
    'taux charges sociales avs ac aanp aap allocations ijm année janvier réglages',
  ],
  [
    'Certificat de travail / de salaire',
    'Fiche employé : « Certificat de travail » (modifiable) et « Certificat de salaire annuel ». N° AVS repris automatiquement.',
    'certificat travail salaire annuel employé',
  ],
  [
    'Lettre de licenciement',
    'Fiche employé : « Résiliation du contrat » — nom, adresse, date du contrat repris automatiquement.',
    'licenciement résiliation contrat fin employé',
  ],
  [
    'Vacances et congés',
    "L'employé demande ses congés (son espace) ; le patron valide dans Équipe & paie. Solde suivi.",
    'vacances congés absence solde valider',
  ],
  [
    'Heures et pointage (chantier)',
    'Sur un chantier, les employés pointent leurs heures (type : normales, sup, déplacement, vacances, maladie…). Les heures alimentent la fiche de salaire.',
    'heures pointage chantier type salaire',
  ],
  [
    'Espace employé',
    "L'employé se connecte comme chacun : son adresse e-mail et son mot de passe, choisis en acceptant l'invitation (Équipe → fiche → « Inviter »), puis un code à 6 chiffres reçu par e-mail ou par SMS. Son espace : pointage, salaire, contrat, congés, communication, + chantier/rapport (bâtiment) ou livraisons (magasin).",
    'espace employé ouvrier connexion code e-mail sms pointage',
  ],
  [
    'Créer un chantier',
    'Chantiers → Nouveau : nom, client, adresse. Suis heures, photos, rapports, matériaux, rentabilité.',
    'chantier créer bâtiment client',
  ],
  [
    "Rentabilité d'un chantier",
    "Sur le chantier : marge = facturé − coûts (main d'œuvre pointée + matériaux + sous-traitants).",
    'rentabilité chantier marge coût bénéfice',
  ],
  [
    'Sortir du matériel pour un chantier',
    "Enregistre une sortie de matériel en choisissant le chantier : le stock diminue, le matériel s'ajoute au chantier.",
    'matériel sortie chantier stock dépôt',
  ],
  [
    'Sous-traitants, avenants, PV',
    'Sur un chantier : sous-traitants, avenants signés, PV de réception de fin de chantier.',
    'sous-traitant avenant pv réception chantier',
  ],
  [
    'Commandes clients',
    'Commandes : enregistre les commandes clients, puis génère un bon de livraison.',
    'commande client livraison',
  ],
  [
    'Bons de livraison',
    'Livraisons : crée un bon (client, adresse, articles, signature). Le livreur suit ses tournées.',
    'livraison bon signature tournée',
  ],
  [
    'Les rôles et permissions',
    '5 rôles : Patron (tout), Technicien (sans compta), Comptable (chiffres), Secrétaire (sans chiffres), Employé (son espace).',
    'rôle permission patron technicien comptable secrétaire employé',
  ],
  [
    'Inviter un employé',
    "Équipe → fiche de l'employé → « ✉️ Inviter » : un lien valable 24 heures, à partager par e-mail, WhatsApp ou SMS (ou envoyé par le serveur si la messagerie est réglée). L'employé choisit son adresse e-mail et son mot de passe, saisit le code à 6 chiffres reçu par e-mail, entre dans son espace et signe son contrat. La fiche suit : envoyée, acceptée, expirée ; « Renvoyer » invalide l'ancien lien.",
    'inviter employé lien invitation e-mail mot de passe compte rôle renvoyer signer contrat',
  ],
  [
    'Je suis aussi salarié de ma société',
    "Équipe & paie → « ➕ M'ajouter comme employé » : ta fiche est créée depuis ton compte (ou reprise si elle existe déjà à ton e-mail) et rattachée à ton compte patron, sans invitation ni second compte. Complète ton contrat (salaire mensuel, taux, date d'entrée, LPP) : ta fiche de salaire du mois, le décompte PDF officiel et le certificat annuel sortent comme pour chaque employé — au forfait mensuel, même sans pointage. Accueil ou Plus → « 👷 Mon espace terrain » ouvre ton espace d'employé sur ta propre fiche : pointage GPS, photos, rapport du jour, matériel, achats, congés, Mon salaire, Mon contrat. Tes congés sont validés d'office et tes achats enregistrés directement : l'approbateur, c'est toi. « ← Retour au bureau » te ramène à la direction.",
    'patron salarié moi-même ma fiche de salaire mon salaire espace terrain employé direction rattacher compte',
  ],
  [
    'Filtre par année',
    'Offres et Factures : les pastilles « Toutes · 2026 · 2025… » filtrent par année.',
    'filtre année offres factures',
  ],
  [
    'Archives (15 ans)',
    "Plus → Archives : sauvegarde complète en JSON, et accès au classeur. Tes documents sont conservés 15 ans, au-delà du minimum légal de 10 ans (art. 958f CO) ; rien n'est supprimé. Le classeur, qui les range par type avec aperçu A4, est dans Comptabilité → 📁 Documents.",
    'archives 15 ans 10 ans conservation légal export sauvegarde classeur',
  ],
  [
    'Sauvegarde / export',
    'Tes données sont enregistrées sur le serveur à chaque modification et sauvegardées là. Réglages → Préférences ou Plus → Archives : « Exporter une sauvegarde » télécharge toutes les données de la société en un fichier JSON (patron).',
    'sauvegarde export json backup données',
  ],
  [
    'Filigrane sur les documents',
    'Réglages → Documents : ajoute un filigrane (logo en fond) sur tes devis/factures.',
    'filigrane watermark logo document',
  ],
  [
    'Dupliquer un document',
    'Sur un devis/facture : « Dupliquer » pour une copie (nouveau numéro).',
    'dupliquer copie devis facture',
  ],
  [
    'Langue des documents',
    "Les documents sont générés en français. L'allemand, l'italien et l'anglais viendront dans une prochaine version.",
    'langue multilingue français allemand italien anglais',
  ],
  [
    'Coupure de réseau',
    'Sans réseau, ta saisie reste à l’écran et repart d’elle-même au retour de la connexion ; un bandeau te le signale. Les données vivent sur le serveur et sont partagées entre tous tes appareils.',
    'hors ligne offline internet synchro',
  ],
  [
    "Installer l'app sur mon téléphone",
    "iPhone/iPad : Partager → « Ajouter à l'écran d'accueil » → SwissTech s'ouvre comme une vraie app.",
    'installer app pwa écran accueil iphone',
  ],
];
